import DataDumpGetter from "segments/DataDumpGetter/DataDumpGetter";
import {
  useProcessIdOnSingleProcessPage,
  useLotInfoForProcessId,
} from "./lotInfoUtils";
import { useSelectedShift } from "utils/customHooks/genericHooks";
import { useIsStorybook } from "utils/customHooks/storyHooks";
import { useTrendChartBarsArrayUnfiltered } from "utils/customHooks/trendChartHooks";
import { UPDATE_LOT_START_DATA_DUMP_FOR_PROCESSES } from "providers/GlobalStateProvider";

export default function DataDumpGetterSinceLotStarted() {
  const processId = useProcessIdOnSingleProcessPage();
  const { lotStartDateMs } = useLotInfoForProcessId(processId);
  const selectedShift = useSelectedShift();
  const didLotStartThisShift =
    lotStartDateMs && lotStartDateMs > selectedShift.range.ge;
  const trendChartBars = useTrendChartBarsArrayUnfiltered();
  const trendChartTimeRanges = trendChartBars.map(({ range }) => range);
  const rangeThatLotStarted = lotStartDateMs
    ? trendChartTimeRanges.find(
        range => range.ge <= lotStartDateMs && lotStartDateMs < range.lt
      )
    : null;
  const endOfHourThatLotStarted = rangeThatLotStarted?.lt;

  const isStorybook = useIsStorybook();
  return !isStorybook && lotStartDateMs && processId ? (
    <DataDumpGetter
      processIds={[processId]}
      timeRange={{
        ge: lotStartDateMs,
        // we use this DDA to get the cumulative count since the lot started,
        // and display that count on the first bar of the current shift.
        // so...
        lt:
          // if the lot started *this* shift, we only need the count between the lot start and the end of that same trend bar
          // (the rest of the bars in this shift show their own counts as usual)
          // so query [lotStart, endOfHourThatLotStarted]
          didLotStartThisShift && endOfHourThatLotStarted
            ? endOfHourThatLotStarted
            : // else if the lot started *before* this shift, we need the cumulative count up to the start of this shift
              // so query [lotStart, startOfShift]
              selectedShift.range.ge,
      }}
      dataDumpAggType={UPDATE_LOT_START_DATA_DUMP_FOR_PROCESSES}
    />
  ) : null;
}
